import * as React from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import ActionButton from '../../ui/ActionButton/ActionButton'

import media from '../../../services/generateMediaQueries'

import RightSideBarHeader from '../../../assets/img/right-sidebar-header.svg'
import { APP_NAME } from '../../../static/constants'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('xsmall')`
    border-radius: 0;
    max-width: unset;
  `}
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;

  ${media.lessThan('small')`
    max-height: unset;
    height: 100vh;
  `}
`

const ModalContent = styled.div`
  flex: 0 0 auto;
  position: relative;
  margin: 3rem auto;
  height: 100%;
  width: 100%;
  max-width: 480px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;

  ${media.lessThan('small')`
    margin: 0;
    max-width: unset;
    width: 100%;
    border-radius: 0;
    overflow: auto;
  `}
`

const ModalPaddedContent = styled.div`
  padding: 0 2rem;
  padding-bottom: 3rem;
`

const ModalHeader = styled.div`
  position: relative;
  height: 244px;
  width: 100%;
  margin-bottom: 1rem;
  background-color: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    bottom: -5px;
    left: 0;
    right: 0;
    display: block;
    background: url('${RightSideBarHeader}');
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 101%;
  }
`

const Title = styled.h2`
  color: var(--color-primary);
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  text-align: center;
  margin: 0;
  margin-bottom: 1.5625rem;
`

const Description = styled.p`
  font-size: 1.125rem;
  line-height: 1.4375rem;
  text-align: center;
  margin: 0;
  margin-bottom: 1rem;
`

const StyledActionButton = styled(ActionButton)`
  display: block;
  margin: 0 auto;
  margin-top: 2.5rem;
`

const Wrap = styled.span`
  white-space: normal;
`

const overlay = {
  zIndex: 999,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function MallWelcomeModal(props) {
  const { show, onConfirmClick, malls = [] } = props

  const activeMalls = malls
    .filter(mall => mall.explore)
    .map(mall => mall.name)
    .sort((a, b) => a.localeCompare(b))
  const displayMalls = activeMalls.slice(0, 5)

  return (
    <StyledReactModal
      isOpen={show}
      style={{ overlay, content }}
      closeTimeoutMS={150}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
    >
      <ModalContentWrapper>
        <ModalContent>
          <ModalHeader />
          <ModalPaddedContent>
            <Title>Welcome to {APP_NAME}</Title>
            <Description>
              Explore {displayMalls.join(', ')}
              {activeMalls.length > 5 ? ', and more' : ''} with our mall maps
              and search feature.
            </Description>
            <Description>
              Find your way to your favorite stores, restaurants, and hangout
              spots.
            </Description>
            <StyledActionButton variant="primary" onClick={onConfirmClick}>
              <Wrap>Zing Your Way and Get Started!</Wrap>
            </StyledActionButton>
          </ModalPaddedContent>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

MallWelcomeModal.defaultProps = {}

MallWelcomeModal.propTypes = {
  // TODO: specify prop types
}

export default MallWelcomeModal
